// src/components/HomonymModal.js
import React from 'react';
import { formatCUIL } from '../../utils/documentFormatter';
import { getInitials } from '../../utils/avatar';

const HomonymModal = ({ homonyms, onSelectClient, onClose }) => {
  const handleKeyDown = React.useCallback((e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  }, [onClose]);

  React.useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);
  
  return (
    <>
    <div className="modal-backdrop fade show rg-modal-backdrop rg-modal-backdrop--seller"></div>
    <div className="modal fade text-left w-100 show rg-modal rg-modal--seller rg-modal--homonym" tabIndex="-1" style={{ display: 'block' }} aria-modal="true" role="dialog" >
      <div className="modal-dialog modal-lg modal-dialog-centered rg-modal__dialog rg-modal__dialog--lg">
        <div className="modal-content rg-modal__content">
          <div className="modal-header rg-modal__header">
            <h6 className="modal-title rg-modal__title">Selecciona el cliente correcto</h6>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body rg-modal__body">
            <p className="rg-modal__body-text">Se encontraron varias personas con el mismo DNI. Selecciona el cliente correcto:</p>
            <div className="rg-modal__cards-grid">
              {homonyms.map((client, index) => (
                <div key={index} className="card profile-card text-center homonym-card ms-1 me-1 rg-modal__profile-card rg-modal__profile-card--selectable" onClick={() => onSelectClient(client)} >
                  <div className="card-body pb-0">
                    <div className="avatar avatar-xl mb-3 rg-modal__avatar">
                      <span className="rg-modal__avatar-initials" aria-hidden>{getInitials(client.name, 'CL')}</span>
                    </div>
                    <h6 className="card-title text-primary rg-modal__profile-name">{client.name}</h6>
                    <p className="text-muted rg-modal__profile-meta">CUIL: {formatCUIL(client.cuit)}</p>
                  </div>
                  <div className='card-footer border-0 m-0 pt-0 rg-modal__profile-footer'>
                    {client.exists ? <span className="badge bg-success rg-modal__status-badge">Cliente Existente</span> : <span className="badge bg-primary rg-modal__status-badge">Nuevo Cliente</span>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default HomonymModal;
